import { useNetwork } from '@/presentation/context/network';
import useVaultIcon from '@/presentation/hooks/useVaultIcon';
import VaultIcon from './VaultIcon';
import { ImgHTMLAttributes } from 'react';

const VaultIconContainer = ({
  vaultId,
  legacy = false,
  ...rest
}: {
  legacy?: boolean;
  vaultId?: string;
} & ImgHTMLAttributes<HTMLImageElement | HTMLSpanElement>) => {
  const { network } = useNetwork();
  const { data: vaultIcon, isSuccess } = useVaultIcon(network, vaultId, legacy);

  const unverified = isSuccess && !vaultIcon;

  return <VaultIcon src={vaultIcon} unverified={unverified} {...rest} />;
};

export default VaultIconContainer;
